module.exports = __webpack_public_path__ + "media/images/turbochargers/turbo3-19d6ef1d43d0ebf9443426a254f53146.png";